import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'UserCardContainer'

    static propTypes = {
      addGroup: PropTypes.func.isRequired,
      changeEmail: PropTypes.func.isRequired,
      changeFirstName: PropTypes.func.isRequired,
      changeLastName: PropTypes.func.isRequired,
      error: PropTypes.bool.isRequired,
      groupsOptions: PropTypes.array.isRequired,
      pending: PropTypes.bool.isRequired,
      removeGroup: PropTypes.func.isRequired,
      resetPassword: PropTypes.func.isRequired,
      user: PropTypes.object.isRequired,
    }

    state = {
      editMode: false,
      email: this.props.user.email,
      firstName: this.props.user.firstName,
      lastName: this.props.user.lastName,
    }

    handleDropdownGroupSelect = (e, { value }) => {
      const { addGroup, user } = this.props

      if (!user.userGroups.find(g => g.id === value)) {
        addGroup(value)
      }
    }

    handleEmail = (e, { value }) => {
      this.setState({ email: value })
    }

    handleFirstName = (e, { value }) => {
      this.setState({ firstName: value })
    }

    handleLastName = (e, { value }) => {
      this.setState({ lastName: value })
    }

    handleSubmit = e => {
      const { changeEmail, changeFirstName, changeLastName, user } = this.props
      const { email, firstName, lastName } = this.state

      e.preventDefault()

      if (email !== user.email) {
        changeEmail(email)
      }

      if (firstName !== user.firstName) {
        changeFirstName(firstName)
      }

      if (lastName !== user.lastName) {
        changeLastName(lastName)
      }
    }

    toggleEditMode = e => {
      const { editMode } = this.state

      e.preventDefault()
      this.setState({ editMode: !editMode })
    }

    render() {
      return (
        <WrappedComponent
          handleDropdownGroupSelect={this.handleDropdownGroupSelect}
          handleEmail={this.handleEmail}
          handleFirstName={this.handleFirstName}
          handleLastName={this.handleLastName}
          handleSubmit={this.handleSubmit}
          toggleEditMode={this.toggleEditMode}
          {...this.props}
          {...this.state}
        />
      )
    }
  }

  return Container
}
